export default __webpack_public_path__ + "static/media/feature.ca9e749f.jpg";